export default __webpack_public_path__ + "static/media/alert.80ce6df8.svg";